import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { dispatchLoadingProfileWithCompanyAndEquipment } from '../../stores/store.utils';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrl: './my-profile.component.scss',
  standalone: false,
})
export class MyProfileComponent implements OnInit {
  constructor(private store: Store) {}

  ngOnInit() {
    dispatchLoadingProfileWithCompanyAndEquipment(this.store);
  }
}
